import {
  CalendarMonthOutlined,
  ChevronRightOutlined,
} from "@mui/icons-material";
import React, { useEffect, useMemo, useState } from "react";
import "../../../../../../css/Staff/HRM/Tab/empDashboard.css";

// import { Bar } from "react-chartjs-2";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import totalSalaryIcon from "../../../../../../Assets/SVG/staffDashboardIcons/TOTAL SALARY PAID.svg";
import totalAttendance from "../../../../../../Assets/SVG/staffDashboardIcons/TOTAL ATTENDENCE.svg";
import totalLeave from "../../../../../../Assets/SVG/staffDashboardIcons/TOTAL LEAVE.svg";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { viewLeaveTypesAPI } from "../../../../../../API/Staff/HRM/Leave/staffLeaveTypeAPI";
import { viewLeaveApplicationsAPICall } from "../../../../../../API/Staff/HRM/Leave/staffLeaveApplicationAPI";
import { fetchAllPayslipAPI } from "../../../../Payroll/parollAPIs";
import axios from "axios";
export const EmployeeDashboard = () => {
  const [value, setValue] = useState(new Date());
  const currentEmpID = localStorage.getItem("EMP_ID");
  const singleEmpData = useSelector((state) => state.singleEmployeeSlice.value);
  const leaveTypeList = useSelector((state) => state.allLeaveTypeSlice.value);
  const [leaveApps, setLeaveApps] = useState([]);
  const [year] = useState(new Date().getFullYear());
  const [empBalanceRows, setEmpBalanceRows] = useState([]); // from payroll balance API
  const [payslips, setPayslips] = useState([]);
  const totalSalaryPaid = useMemo(() =>
    (Array.isArray(payslips) ? payslips : []).reduce((s, p) => s + Number(p?.netSalary ?? p?.netAmount ?? 0), 0)
  , [payslips]);
  const leaveUsageByType = useMemo(() => {
    // Prefer payroll balance API used values when available
    if (Array.isArray(empBalanceRows) && empBalanceRows.length) {
      const byType = {};
      empBalanceRows.forEach(b => {
        const key = b?.leaveType || b?.leaveTypeName || b?.code || '';
        if (!key) return;
        byType[key] = Number(b?.used ?? 0);
      });
      return byType;
    }
    // Fallback to sum from applications
    const map = {};
    const apps = Array.isArray(leaveApps) ? leaveApps : [];
    apps.forEach(l => {
      const lt = typeof l.leaveType === 'object' ? (l.leaveType?.leaveType || l.leaveType?.name || l.leaveType?._id) : l.leaveType;
      const days = Number(l?.days ?? 0);
      if (!lt) return;
      map[lt] = (map[lt] || 0) + days;
    });
    return map;
  }, [leaveApps, empBalanceRows]);
  const totalLeaveUsed = useMemo(() => Object.values(leaveUsageByType).reduce((a,b)=>a+Number(b||0),0), [leaveUsageByType]);
  const findLeaveTypeByName = (name) => {
    const list = Array.isArray(leaveTypeList) ? leaveTypeList : [];
    return list.find(lt =>
      [lt?.leaveType, lt?.name]
        .filter(Boolean)
        .some(v => String(v).toLowerCase().includes(String(name).toLowerCase()))
    );
  };
  const getLeaveBadge = (name, fallbackTotal = 365) => {
    // If balance rows exist, derive from them by fuzzy matching
    if (Array.isArray(empBalanceRows) && empBalanceRows.length) {
      const row = empBalanceRows.find(r => String(r?.leaveType || '').toLowerCase().includes(String(name).toLowerCase()));
      if (row) return { label: row.leaveType, used: Number(row.used||0), allotted: Number(row.allocated||row.available+row.used||fallbackTotal) };
    }
    const lt = findLeaveTypeByName(name) || {};
    const label = lt?.leaveType || lt?.name || name;
    const allotted = Number(lt?.numberOfDays ?? fallbackTotal);
    const used = Number(leaveUsageByType[label] || 0);
    return { label, used, allotted };
  };
  const paidBadge = getLeaveBadge('Paid');
  const sickBadge = getLeaveBadge('Sick', 10);
  const unpaidBadge = getLeaveBadge('Unpaid');
  const totalCommission = useMemo(() => {
    const list = Array.isArray(payslips) ? payslips : [];
    let sum = 0;
    list.forEach(ps => {
      (ps?.earnings || []).forEach(e => {
        const key = e?.earningsType || e?.name || '';
        if (String(key).toLowerCase().includes('commission')) {
          sum += Number(e?.amount || 0);
        }
      });
    });
    return sum;
  }, [payslips]);

  const navigateTo = useNavigate();
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Salary, Attendance & Leave Chart",
      },
    },
  };

  const labels = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const data = {
    labels,
    datasets: [
      {
        label: "Salary",
        data: [
          "13",
          "70",
          "30",
          "12",
          "77",
          "12",
          "64",
          "48",
          "67",
          "103",
          "15",
          "97",
        ],
        backgroundColor: "#14a23a",
        barThickness: 8,
      },
      {
        label: "Attendance",
        data: [
          "10",
          "40",
          "50",
          "12",
          "77",
          "12",
          "64",
          "48",
          "67",
          "103",
          "37",
          "90",
        ],
        backgroundColor: "#acb9fe",
        barThickness: 8,
      },
      {
        label: "Leave",
        data: [
          "24",
          "35",
          "45",
          "12",
          "11",
          "97",
          "28",
          "20",
          "77",
          "30",
          "14",
          "33",
        ],
        backgroundColor: "#e75757",
        barThickness: 8,
      },
    ],
  };

  const ClickTotalCommission = () => {
    navigateTo("viewEmpTotalCommission");
  };

  useEffect(() => {
    viewLeaveTypesAPI();
  }, []);

  useEffect(() => {
    if (!currentEmpID) return;
    viewLeaveApplicationsAPICall(
      { branchId: singleEmpData?.branchId, empId: currentEmpID },
      undefined
    );
  }, [currentEmpID, singleEmpData?.branchId]);

  // Load payroll leave balance for the employee as source of truth
  useEffect(() => {
    let mounted = true;
    const loadBalance = async () => {
      try {
        const res = await axios.get(`payroll/leave/balance/report?year=${year}`);
        if (res?.status === 200) {
          const employees = res.data?.employees || [];
          const me = employees.find(e => String(e?.employeeId) === String(currentEmpID));
          const rows = me?.balances || [];
          if (mounted) setEmpBalanceRows(rows);
        }
      } catch (e) {
        // silent fail: fallback to applications computation
        if (mounted) setEmpBalanceRows([]);
      }
    };
    if (currentEmpID) loadBalance();
    return () => { mounted = false };
  }, [currentEmpID, year]);

  useEffect(() => {
    let mounted = true;
    const loadPayslips = async () => {
      if (!currentEmpID) return;
      await fetchAllPayslipAPI({
        body: { page: 1, limit: 200, empId: currentEmpID },
        successCallback: (res) => {
          const list = res?.data?.list || res?.list || [];
          const filtered = list.filter(
            (ps) => String(ps?.empId?._id || ps?.employeeDetails?._id || ps?.empId) === String(currentEmpID)
          );
          if (mounted) setPayslips(filtered.length ? filtered : list);
        },
        errorCallback: () => {}
      });
    };
    loadPayslips();
    return () => { mounted = false };
  }, [currentEmpID]);

  const allLeaveApplications = useSelector((state) => state.allLeaveApplicationSlice.value);
  useEffect(() => {
    const arr = Array.isArray(allLeaveApplications) ? allLeaveApplications : [];
    const filtered = arr.filter((l) => String(l?.employeeId || l?.empId?._id || l?.empId) === String(currentEmpID));
    setLeaveApps(filtered);
  }, [allLeaveApplications, currentEmpID]);

  return (
    <>
      <div className="employee-dashborad-top-container">
        <div className="employee-dashboard-date-time-picker">
          <div className="employee-dashboard-date-picker">
            {/* <CalendarMonthOutlined className="calendar-icon" /> */}
            {/* <hr className='date-picker-hr'/> */}
            <input type="date" />
          </div>
          <div className="employee-dashboard-time-picker">
            {/* <AccessTimeIcon/> */}
            <input type="time" />
          </div>
        </div>
      </div>
      {/* card */}
      <div className="employee-dashboard-card-container">
        <div className="employee-dashboard-card">
          <div className="employee-dashboard-card-icon-container">
            <img src={totalSalaryIcon} alt="total salary" />
          </div>
          <div className="employee-dashboard-card-text-container">
            <h5>Total Salary Paid</h5>
            <p>Rs {Number(totalSalaryPaid || 0).toLocaleString()}</p>
          </div>
          <div className="employee-dashboard-card-arrow-icon-container">
            <ChevronRightOutlined sx={{ color: "#fff" }} />
          </div>
        </div>
        <div className="employee-dashboard-card">
          <div
            className="employee-dashboard-card-icon-container"
            style={{ backgroundColor: "#4da214" }}
          >
            <img src={totalAttendance} alt="total attendance" />
          </div>
          <div className="employee-dashboard-card-text-container">
            <h5>Total Attendance</h5>
            <p>-</p>
          </div>
          <div
            className="employee-dashboard-card-arrow-icon-container"
            style={{ backgroundColor: "#4da214" }}
          >
            <ChevronRightOutlined sx={{ color: "#fff" }} />
          </div>
        </div>
        <div className="employee-dashboard-card">
          <div
            className="employee-dashboard-card-icon-container"
            style={{ backgroundColor: "#f24949" }}
          >
            <img src={totalLeave} alt="total leave" />
          </div>
          <div className="employee-dashboard-card-text-container">
            <h5>Total Leave</h5>
            <p>{Number(totalLeaveUsed || 0)}</p>
          </div>
          <div
            className="employee-dashboard-card-arrow-icon-container"
            style={{ backgroundColor: "#f24949" }}
          >
            <ChevronRightOutlined sx={{ color: "#fff" }} />
          </div>
        </div>
        <div className="employee-dashboard-card">
          <div
            className="employee-dashboard-card-icon-container"
            style={{ backgroundColor: "#1498a2" }}
          >
            <img src={totalAttendance} alt="total attendance" />
          </div>
          <div className="employee-dashboard-card-text-container">
            <h5>Total Transfer</h5>
            <p>-</p>
          </div>
          <div
            className="employee-dashboard-card-arrow-icon-container"
            style={{ backgroundColor: "#1498a2" }}
          >
            <ChevronRightOutlined sx={{ color: "#fff" }} />
          </div>
        </div>
        <div className="employee-dashboard-card">
          <div
            className="employee-dashboard-card-icon-container"
            style={{ backgroundColor: "rgb(255 25 79)" }}
          >
            <div className="employee-dashboard-card-icon-container-circle">
              %
            </div>
          </div>
          <div className="employee-dashboard-card-text-container">
            <h5>Total Commission</h5>
            <p>{Number(totalCommission || 0).toLocaleString()}</p>
          </div>
          <div
            className="employee-dashboard-card-arrow-icon-container"
            style={{ backgroundColor: "rgb(255 25 79)" }}
            onClick={ClickTotalCommission}
          >
            <ChevronRightOutlined sx={{ color: "#fff" }} />
          </div>
        </div>
      </div>

      {/* grpah and calender */}
      <div className="employee-dashboard-graph-calender-container">
        <div className="employee-dashboard-graph-container">
          {/* <Bar options={options} data={data} /> */}
        </div>
        <div className="employee-dashboard-calender-container">
          <div className="employee-dashboard-calender-top-container">
            <h4>Calendar</h4>
          </div>
          <div className="employee-dashboard-calender-second-container">
            <Calendar
              onChange={setValue}
              value={value}
              className="custom-calendar"
            />
          </div>
        </div>
      </div>

      {/* leave and holidays container */}
      <div className="leave-holidays-container">
        <div className="leave-details-container">
          <div className="leave-details-top-container">
            <h3>Leave Details</h3>
            <div className="leave-details-top-right-container">
              <div className="leave-details-top-right-child-container">
                <h5>Paid Leave</h5>
                <p>{paidBadge.used}&nbsp;/&nbsp;{paidBadge.allotted}</p>
              </div>
              <div className="leave-details-top-right-child-container">
                <h5 style={{ color: "#ff0000" }}>Sick Leave</h5>
                <p style={{ color: "#ff0000" }}>{sickBadge.used}&nbsp;/&nbsp;{sickBadge.allotted}</p>
              </div>
              <div className="leave-details-top-right-child-container">
                <h5 style={{ color: "#0019ff" }}>Unpaid Leave</h5>
                <p style={{ color: "#0019ff" }}>{unpaidBadge.used}&nbsp;/&nbsp;{unpaidBadge.allotted}</p>
              </div>
            </div>
          </div>
          <div className="leave-details-table-container">
            <table>
              <thead>
                <tr>
                  <th>Leave Type</th>
                  <th>Used</th>
                  <th>Balanced</th>
                </tr>
              </thead>
              <tbody>
                {(empBalanceRows && empBalanceRows.length ? empBalanceRows : (Array.isArray(leaveTypeList) ? leaveTypeList : []).map(lt=>({
                  leaveType: lt?.leaveType || lt?.name || lt?._id,
                  allocated: lt?.numberOfDays ?? 0,
                  used: Number(leaveUsageByType[lt?.leaveType || lt?.name || lt?._id] || 0)
                })) ).map((row) => {
                  const name = row.leaveType;
                  const allotted = Number(row.allocated ?? 0);
                  const used = Number(row.used ?? 0);
                  const balanced = Math.max(allotted - used, 0);
                  return (
                    <tr key={name}>
                      <td className="left-head">{name}</td>
                      <td>{used}</td>
                      <td className="leave-table-balance">{balanced}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
          {/* <button className='btn btn-primary dashboard-apply-leave-btn btn-font-size-less'>Apply For Leave</button> */}
        </div>
        <div className="holiday-container">
          <h3>Upcoming Holidays</h3>
          <div className="holiday-content-container">
            <div className="holiday-content-container-single-container">
              <div className="holiday-single-container-box">
                <p className="date">15</p>
                <p className="month">Mar</p>
              </div>
              <div className="holiday-single-container-middle-text">
                <h4>Public Holiday</h4>
                <p>Public Holiday</p>
              </div>
              <div className="holiday-single-container-last-text">
                <p>13 Days Left</p>
              </div>
            </div>
            <div className="holiday-content-container-single-container">
              <div
                style={{ backgroundColor: "#efe0ff", color: "#bd36ff" }}
                className="holiday-single-container-box"
              >
                <p className="date">15</p>
                <p className="month">Mar</p>
              </div>
              <div className="holiday-single-container-middle-text">
                <h4>Public Holiday</h4>
                <p>Public Holiday</p>
              </div>
              <div className="holiday-single-container-last-text">
                <p>13 Days Left</p>
              </div>
            </div>
            <div className="holiday-content-container-single-container">
              <div
                style={{ backgroundColor: "#e0f0ff", color: "#0088ff" }}
                className="holiday-single-container-box"
              >
                <p className="date">15</p>
                <p className="month">Mar</p>
              </div>
              <div className="holiday-single-container-middle-text">
                <h4>Public Holiday</h4>
                <p>Public Holiday</p>
              </div>
              <div className="holiday-single-container-last-text">
                <p>13 Days Left</p>
              </div>
            </div>
            <div className="holiday-content-container-single-container">
              <div
                style={{ backgroundColor: "#fffce0", color: "#ffee00" }}
                className="holiday-single-container-box"
              >
                <p className="date">15</p>
                <p className="month">Mar</p>
              </div>
              <div className="holiday-single-container-middle-text">
                <h4>Public Holiday</h4>
                <p>Public Holiday</p>
              </div>
              <div className="holiday-single-container-last-text">
                <p>13 Days Left</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
